module.exports = __webpack_public_path__ + "media/hra1.02cb084e.mp3";